export const initialState = {
  profilePics: {},
  logoImage: "",
  userPassword: "",
  forumAdminApiKey: "",
  document: "",
  provisionParams: {
    pwd: "",
    vm_template: "",
    cloud: "",
    hostedpage_id: ""
  },
  pricingPlans: []
};

export const GlobalActionTypes = {
  SET_PROFILE_PICS: "SET_PROFILE_PICS",
  SET_LOGO_IMAGE: "SET_LOGO_IMAGE",
  SET_PASSWORD: "SET_PASSWORD",
  SET_FORUM_ADMIN_API_KEY: "SET_FORUM_ADMIN_API_KEY",
  SET_APP_DOCUMENTS: "SET_APP_DOCUMENTS",
  SET_PROV_PARAMS: "SET_PROV_PARAMS",
  SET_PRICING_PLANS: "SET_PRICING_PLANS"
};

export function globalReducer(state = initialState, action) {
  switch (action.type) {
    case GlobalActionTypes.SET_PROFILE_PICS: {
      const { userid, img } = action.payload;

      return {
        ...state,
        profilePics: {
          ...state.profilePics,
          [userid]: img
        }
      };
    }

    case GlobalActionTypes.SET_LOGO_IMAGE: {
      const { img } = action.payload;

      return {
        ...state,
        logoImage: img
      };
    }

    case GlobalActionTypes.SET_PASSWORD: {
      return {
        ...state,
        userPassword: action.payload
      };
    }

    case GlobalActionTypes.SET_FORUM_ADMIN_API_KEY: {
      return {
        ...state,
        forumAdminApiKey: action.payload
      };
    }
    case GlobalActionTypes.SET_APP_DOCUMENTS: {
      return {};
    }

    case GlobalActionTypes.SET_PROV_PARAMS: {
      return {
        ...state,
        provisionParams: action.payload
      };
    }

    case GlobalActionTypes.SET_PRICING_PLANS: {
      return {
        ...state,
        pricingPlans: action.payload
      };
    }

    default:
      return state;
  }
}
